import { render, staticRenderFns } from "./DeleteDeviceCategories.vue?vue&type=template&id=2f8cabf4"
import script from "./DeleteDeviceCategories.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports